import $ from 'jquery';

import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { middleware as thunkMiddleware } from 'redux-saga-thunk';
import thunk from 'redux-thunk';
import cookies from 'js-cookie';
import { createCookieMiddleware } from './redux-utils/reduxCookie';
import { middlewares as legacyMiddleware } from './middleware/index';
import createReducer from './reducers';
import appSaga from './appSaga';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

window.$ = $;
window.jQuery = $;

const sagaMiddleware = createSagaMiddleware();

export const configureStore = (initialState = {}) => {
  const middlewares = [
    thunkMiddleware,
    sagaMiddleware,
    createCookieMiddleware(cookies),
    thunk,
    legacyMiddleware,
  ];
  const enhancers = [applyMiddleware(...middlewares)];

  // If Redux DevTools Extension is installed use it, otherwise use Redux compose
  /* eslint-disable no-underscore-dangle */
  const composeEnhancers =
    process.env.NODE_ENV !== 'production' &&
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      : compose;
  /* eslint-enable */

  const store = createStore(
    createReducer(),
    initialState,
    composeEnhancers(...enhancers),
  );

  store.runSaga = sagaMiddleware.run;
  store.injectedReducers = {};
  store.injectedSagas = {};

  store.runSaga(appSaga);

  return store;
};

// this initialization should be when
// the application is created eje react/index.js
const initialState = {};
export const store = configureStore(initialState);
